import { PageHero } from "@/components/PageHero";
import { SectionHeading } from "@/components/SectionHeading";
import { ContactCards, MapPlaceholder } from "@/components/ContactCards";
import { Button } from "@/components/Button";
import { Reveal } from "@/components/Reveal";
import { siteConfig } from "@/data/siteConfig";
import { useSiteContent } from "@/context/ContentContext";

export default function Contact() {
  const { company } = siteConfig;
  const { contact } = useSiteContent();
  return (
    <>
      <PageHero kicker="Contact" title="Get in Touch"
        text={`${company.name}. Send your parts enquiry or reach us directly.`} />

      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <ContactCards />

          <div className="mt-12 grid gap-10 lg:grid-cols-[1fr_1.3fr]">
            <Reveal>
              <SectionHeading kicker="Details" title="Business Information" />
              <dl className="mt-8 space-y-5 text-sm">
                <div><dt className="font-semibold uppercase tracking-wider text-ink text-xs">Address</dt><dd className="mt-1 text-muted">{contact.address}</dd></div>
                <div><dt className="font-semibold uppercase tracking-wider text-ink text-xs">Phone</dt><dd className="mt-1"><a href={`tel:${contact.phone}`} className="text-muted hover:text-amber-hover transition-colors" data-testid="contact-tel">{contact.phoneDisplay}</a></dd></div>
                <div><dt className="font-semibold uppercase tracking-wider text-ink text-xs">Email</dt><dd className="mt-1"><a href={`mailto:${contact.email}`} className="text-muted hover:text-amber-hover transition-colors break-words" data-testid="contact-mailto">{contact.email}</a></dd></div>
              </dl>
              <div className="mt-8"><Button to="/request-a-quote" variant="accent" arrow data-testid="contact-quote-btn">Request a Quote</Button></div>
            </Reveal>
            <div className="min-h-[360px]"><MapPlaceholder /></div>
          </div>
        </div>
      </section>
    </>
  );
}
